import ClientItem from 'owa-mail-store/lib/store/schema/ClientItem';
import { CalendarEvent } from 'mini-calendar-event-types';
import { convertMailMeetingItemToCalendarEvent } from 'mini-meeting-invite/lib/utils/convertMailMeetingItemToCalendarEvent';
import { trace } from 'owa-trace';
import { useEffect, useState } from 'react';
import { usePrevious } from 'mini-hooks/lib/usePrevious';

/* Converts meeting Item from mail list row to a calendar event  */
export const useCalendarEventFromMeetingItem = (
    meetingClientItem: ClientItem,
    fullFetch: boolean = false,
    onConversionToCalEvent?: (convertedCalendarEvent: CalendarEvent) => void
) => {
    const [calendarEvent, setCalendarEvent] = useState<CalendarEvent>(null);
    const previousCalendarEvent = usePrevious<CalendarEvent>(calendarEvent, null);

    useEffect(() => {
        if (!meetingClientItem || previousCalendarEvent !== calendarEvent) {
            // We short circuit when render is triggered due to calEvent Change
            return;
        }
        convertMailMeetingItemToCalendarEvent(meetingClientItem, fullFetch)
            .then(calEvent => {
                setCalendarEvent(calEvent);
                onConversionToCalEvent?.(calEvent);
            })
            .catch(error => {
                trace.warn(
                    `[convertingMeetingItemToCalendarEvent] Couldn't convert meeting item to calendar event for itemId: ${meetingClientItem.ItemId?.Id}. Failed with error: ${error}`
                );
            });
    });

    return calendarEvent;
};
